/* eslint-disable no-unused-vars */
import { useQuery } from '@tanstack/react-query';
import ApiError from 'errors/ApiError';
import { useMemo } from 'react';
import { useUserData } from 'user/hooks/useUserData';

// also used by asset existence
export const getAircraftExistence = async (token, queryKey) => {
  // Extract the tailnumber from the queryKey
  const [,, reg_n_number, company_id] = queryKey;

  const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/checkAircraftExists?reg_n_number=${reg_n_number}&company_id=${company_id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new ApiError(response, data);
  }

  return {
    response,
    responseData: data,
  };
};

export const getQueryKey = (reg_n_number, company_id) => ['aircraftGlobals', 'doesAircraftExist', reg_n_number, company_id];

export function useAircraftExistence(reg_n_number, company_id) {
  const { userData } = useUserData();
  const { token } = userData;
  const key = useMemo(() => getQueryKey(reg_n_number, company_id), [reg_n_number, company_id]);

  const query = useQuery({
    queryKey: key,
    queryFn: ({ queryKey }) => getAircraftExistence(token, queryKey),
    enabled: !!reg_n_number,
  });

  return {
    query,
    fullResponse: query?.data?.responseData || {},
    aircraftExistence: query?.data?.responseData?.data || {},
  };
}
